<template lang="pug">
SspLayout(area="core")
  template(slot="actions")
    label(for="showIncidents") Show incidents:
    .spacer
    input#showIncidents(type="checkbox" v-model="showIncidents" @change="toggleIncidents(showIncidents)" :disabled="!geofence.id")
    .spacer
    router-link.btn.btn-default(:to="{name: 'order', params: {id: orderId}}") Cancel
    .spacer
    SspActionButton(@onClick="save" :spinning="saving")

  span.error-handling {{errorMsg}}

  .geofence(v-if="gmapLoaded")
    .row
      LocationsTree.col-md-5.scrollable(v-model="location")
      .col-md-7
        .row
          GmapMap(ref="map" :center="center" :markers="markers" :zoom="2" style="width: 800px; height: 500px;" @zoom_changed="redrawBoundaries()" @bounds_changed="redrawBoundaries()")
            GmapMarker(:key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :draggable="false" @click="openInfoWindow(m)")
            GmapInfoWindow(:options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false")
            GmapPolygon(:paths="boundaries" :editable="false" :options="{fillColor: 'grey',strokeWeight: 1}")
            GmapPolygon(:paths="allowBoundaries" :editable="false" :options="{fillColor: 'green',strokeWeight: 1}")
            GmapPolygon(:paths="restrictBoundaries" :editable="false" :options="{fillColor: 'red',strokeWeight: 1}")
        .row.col-md-12 &nbsp;
        .row(v-if="location.name")
          .col-md-12.text-right
            span {{location.name}}&nbsp;
            button.btn.btn-default(@click="allowLocation(location)" :disabled="!canAllowOrForbidLocation")
              i.fa.fa-check &nbsp;Allow
            button.btn.btn-default(@click="forbidLocation(location)" :disabled="!canAllowOrForbidLocation")
              i.fa.fa-close &nbsp;Forbid
        .row.col-md-12 &nbsp;
        .row
          .col-md-6
            .panel.panel-default
              .panel-heading.pantel-title Allowed
              .panel-body
                .locations-list(v-for="l in geofence.innerLocations")
                  .row
                    .col-md-11(@click="selectLocation(l)") {{l.id}} - {{l.name}}
                    .col-md-1
                    i.fa.fa-trash(@click="clear(l, geofence.innerLocations)")
          .col-md-6
            .panel.panel-default
              .panel-heading.pantel-title Forbidden
              .panel-body
                .locations-list(v-for="l in geofence.outerLocations")
                  .row
                    .col-md-11(@click="selectLocation(l)") {{l.id}} - {{l.name}}
                    .col-md-1
                      i.fa.fa-trash(@click="clear(l, geofence.outerLocations)")
</template>

<script>
import miniToastr from 'mini-toastr'
import debounce from 'debounce'
import Core from '@/service/apis/Core'
import LocationsTree from '@/components/common/LocationsTree'
import GmapLazy from '@/utils/GmapLazy'

export default {
  data: () => ({
    saving: false,
    errorMsg: null,
    infoContent: '',
    infoWindowPos: {
      lat: 0,
      lng: 0
    },
    infoWinOpen: false,
    infoOptions: {
      pixelOffset: {
        width: 0,
        height: -35
      }
    },
    validations: [],
    showIncidents: false,
    geofence: {
      innerLocations: [],
      outerLocations: []
    },
    boundaries: [],
    allowBoundaries: [],
    restrictBoundaries: [],
    location: {},
    gmapLoaded: false
  }),
  methods: {
    drawBoundary(bnd, locationId, clearIt = true) {
      const map = this.$refs.map.$mapObject
      const bb = map.getBounds()
      const ne = bb.getNorthEast()
      const sw = bb.getSouthWest()

      Core.findPreviewBoundary(locationId, Math.min(sw.lng(), ne.lng()), Math.max(ne.lng(), sw.lng()), Math.min(ne.lat(), sw.lat()), Math.max(sw.lat(), ne.lat()), map.getDiv().offsetHeight, map.getDiv().offsetWidth)
        .then((b) => {
          if (clearIt) {
            bnd.splice(0, bnd.length)
          }
          b.data.coordinates.map((c) => {
            const bs = c.map((c2) => {
              if (b.data.type === 'MultiPolygon') {
                bnd.push(c2.map((c3) => ({ lat: c3[1], lng: c3[0] })))
              } else if (b.data.type === 'Polygon') {
                return { lat: c2[1], lng: c2[0] }
              } else {
                this.$emit('error', `Unknown polygon type ${b.data.type}`)
              }
              return {}
            })
            if (b.data.type === 'Polygon') {
              bnd.push(bs)
            }
            return bs
          })
        })
        .catch((e) => {
          if (e.response && e.response.status !== '404') {
            this.$emit('error', e)
          }
        })
    },
    openInfoWindow(marker) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      this.infoWinOpen = true
    },
    toggleIncidents(showIncidents) {
      if (showIncidents) {
        Core.retreiveGeofenceFailedValidations(this.geofence.id)
          .then((r) => {
            this.validations = r.data.map((e) => {
              const val = {
                position: { lat: e.coordinates.lat, lng: e.coordinates.lng },
                infoText: e.responseMsg
              }
              return val
            })
          })
      } else {
        this.validations = []
        this.infoWinOpen = false
      }
    },
    selectLocation(l) {
      this.location = l
    },
    redrawBoundaries() {
      if (this.location.id) {
        this.drawBoundary(this.boundaries, this.location.id)
      }

      this.allowBoundaries = []
      this.geofence.innerLocations.forEach((loc) => {
        this.drawBoundary(this.allowBoundaries, loc.id, false)
      })

      this.restrictBoundaries = []
      this.geofence.outerLocations.forEach((loc) => {
        this.drawBoundary(this.restrictBoundaries, loc.id, false)
      })
    },
    clear(l, list) {
      const i = list.findIndex((e) => e.id === l.id)
      if (i >= 0) {
        list.splice(i, 1)
      }
      this.redrawBoundaries()
    },
    save() {
      this.saving = true
      const g = this.geofence
      const newG = { id: g.id, orderId: this.orderId, sectionId: this.sectionId }
      newG.innerLocations = g.innerLocations.map((l) => l.id)
      newG.outerLocations = g.outerLocations.map((l) => l.id)
      if (!newG.id) {
        return Core.createGeofence(newG)
          .then(() => {
            miniToastr.success('Successully saved geofence')
          })
          .catch((e) => {
            this.$emit('error', e)
          })
          .then(() => {
            this.saving = false
          })
      }
      return Core.updateGeofence(newG)
        .then(() => {
          miniToastr.success('Successully updated geofence')
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    },
    allowLocation(l) {
      this.geofence.innerLocations.push(l)
      this.boundaries = []
      this.redrawBoundaries()
    },
    forbidLocation(l) {
      this.geofence.outerLocations.push(l)
      this.boundaries = []
      this.redrawBoundaries()
    },
    onGmapLoaded() {
      this.gmapLoaded = true
      this.redrawBoundaries = debounce(this.redrawBoundaries, 50)
      let loadFunction
      if (this.sectionId) {
        this.geofence.sectionId = this.sectionId
        loadFunction = Core.loadGeofenceBySectionId(this.sectionId)
      } else if (this.orderId) {
        this.geofence.orderId = this.orderId
        loadFunction = Core.loadGeofenceByOrderId(this.orderId)
      }

      loadFunction
        .then((r) => {
          this.geofence = r.data
          this.redrawBoundaries()
        })
        .catch((e) => {
          if (e.response && e.response.status !== '404') {
            this.$emit('error', e)
          }
        })
    }
  },
  watch: {
    location(l) {
      if (l.id) {
        this.drawBoundary(this.boundaries, l.id)
        this.openInfoWindow({ position: l.coordinates, infoText: l.name })
      }
    }
  },
  computed: {
    canAllowOrForbidLocation() {
      return this.geofence.innerLocations.findIndex((e) => e.id === this.location.id) < 0 && this.geofence.outerLocations.findIndex((e) => e.id === this.location.id) < 0
    },
    markers() {
      const ms = this.location && this.location.coordinates ? [{ position: this.location.coordinates, infoText: this.location.name }] : []
      if (this.validations.length > 0) {
        return ms.concat(this.validations)
      }
      return ms
    },
    center() {
      return this.location && this.location.coordinates ? this.location.coordinates : { lat: 0, lng: 0 }
    },
    orderId() {
      return parseInt(this.$route.params.id, 10)
    },
    sectionId() {
      return parseInt(this.$route.params.sectionId, 10)
    }
  },
  mounted() {
    GmapLazy.loadGmap()
      .then(this.onGmapLoaded)
  },
  components: {
    LocationsTree
  }
}
</script>

<style lang="scss">
  .scrollable {
    height: 500px;
    overflow: scroll;
  }
  .geofence {
    .locations-list {
      cursor: pointer;
    }
    .locations-list:hover {
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/core/Geofence.vue